"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Network: () => Network,
  useNetworkState: () => useNetworkState
});
module.exports = __toCommonJS(index_native_exports);
var import_react = require("react");
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_validate = require("./validate");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneNetwork");
  return hybrid;
}
function getState() {
  return native().getState().catch(import_nativeError.rethrowNativeError);
}
function addStateListener(listener) {
  (0, import_validate.assertStateListener)(listener);
  var remove = native().addStateListener(listener);
  return {
    remove: function remove1() {
      return remove();
    }
  };
}
function useNetworkState() {
  var [state, setState] = (0, import_react.useState)({
    type: "unknown",
    isConnected: false,
    isInternetReachable: false
  });
  (0, import_react.useEffect)(function() {
    var active = true;
    var sawEvent = false;
    getState().then(function(next) {
      if (active && !sawEvent) setState(next);
    }).catch(function() {
    });
    var subscription = addStateListener(function(next) {
      sawEvent = true;
      if (active) setState(next);
    });
    return function() {
      active = false;
      subscription.remove();
    };
  }, []);
  return state;
}
var Network = Object.freeze({
  getState,
  addStateListener
});
//# sourceMappingURL=index.native.js.map
